<h1 class="text-center" [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.ausstieg.headline' | translate"></h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-3">
    <app-advisor-image path="/pvc/pvc-ausstieg.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-9 large-8">
    <p [innerHTML]="(textkeyPrefix + '.verbrauchsanalyse.ausstieg') | translate"></p>
    <div class="callout" >
      <p [innerHTML]="(textkeyPrefix + '.verbrauchsanalyse.ausstieg.' + case) | translate"></p>
      <div class="text-center">
        <a class="button inline-arrow-right" [href]="startUrl" [innerHTML]="(textkeyPrefix + '.verbrauchsanalyse.ausstieg.button') | translate: {url: startUrl} "></a>
      </div>
    </div>
  </div>
</div>

<app-step-buttons [previousLink]="lastStep" [nextLink]="null" [nextSubmit]="false" mediumWidthRight="9" mediumOffset="3" leftAlignSize="medium" largeOffset="3" largeWidthRight="8" [nextText]="textkeyPrefix + '.verbrauchsanalyse.start.next'"></app-step-buttons>

